import { BrowserCacheLocation } from '@azure/msal-browser';
import { IAuthConfig } from '../auth.types';
import { loggerCallback } from '../logger/logger';

export const estacio: IAuthConfig[] = [
  {
    envs: ['local'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'e37af882-da85-4833-8d0b-f5a71a215496',
          authority: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.dev.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signup',
        scope: 'https://estaciodev.onmicrosoft.com/e37af882-da85-4833-8d0b-f5a71a215496/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.dev.portal.estacio.br',
      },
    },
    applicationUrl: 'http://localhost:3000',
  },
  {
    envs: ['local'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'bd215e16-5d5c-4152-b918-485d25e06e44',
          authority: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.dev.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signup',
        scope: 'https://estaciodev.onmicrosoft.com/bd215e16-5d5c-4152-b918-485d25e06e44/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.dev.portal.estacio.br',
      },
    },
    applicationUrl: 'http://localhost:3005',
  },
  {
    envs: ['dev'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'e37af882-da85-4833-8d0b-f5a71a215496',
          authority: 'https://estaciodev.b2clogin.com/estaciodev.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['estaciodev.b2clogin.com'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://estaciodev.b2clogin.com/estaciodev.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://estaciodev.onmicrosoft.com/e37af882-da85-4833-8d0b-f5a71a215496/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.dev.portal.estacio.br',
      },
    },
    applicationUrl: 'https://candidato.estacio.sava.dev.yduqs.com.br',
  },
  {
    envs: ['dev'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'bd215e16-5d5c-4152-b918-485d25e06e44',
          authority: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.dev.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.estacio.br/estaciodev.onmicrosoft.com/B2C_1_signup',
        scope: 'https://estaciodev.onmicrosoft.com/bd215e16-5d5c-4152-b918-485d25e06e44/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.dev.portal.estacio.br',
      },
    },
    applicationUrl: 'https://experimente.dev.estacio.br',
  },
  {
    envs: ['qld'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '8fbd2814-d472-447f-b05a-268b13b964dd',
          authority: 'https://estacioqas.b2clogin.com/estacioqas.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['estacioqas.b2clogin.com'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://estacioqas.b2clogin.com/estacioqas.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://estacioqas.onmicrosoft.com/8fbd2814-d472-447f-b05a-268b13b964dd/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.qa.portal.estacio.br',
      },
    },
    applicationUrl: 'https://candidato.estacio.sava.qld.yduqs.com.br',
  },
  {
    envs: ['qld'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '23219988-8cb3-48f1-af90-5926729b0d61',
          authority: 'https://login.qa.estacio.br/estacioqas.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.qa.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.qa.estacio.br/estacioqas.onmicrosoft.com/B2C_1_signup',
        scope: 'https://estacioqas.onmicrosoft.com/23219988-8cb3-48f1-af90-5926729b0d61/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.qa.portal.estacio.br',
      },
    },
    applicationUrl: 'https://experimente.qa.estacio.br',
  },
  {
    envs: ['prd'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '61aa1062-77e6-4368-99a8-15461de025a1',
          authority: 'https://login.estacio.br/loginestacio.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['login.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.estacio.br/loginestacio.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://loginestacio.onmicrosoft.com/61aa1062-77e6-4368-99a8-15461de025a1/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.portal.estacio.br',
      },
    },
    applicationUrl: 'https://candidatos.sava.estacio.br',
  },
  {
    envs: ['prd'],
    brands: ['estacio'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'e62ba000-3cf5-463c-bfb2-2a632612a99a',
          authority: 'https://login.estacio.br/loginestacio.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.estacio.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.estacio.br/loginestacio.onmicrosoft.com/B2C_1_signup',
        scope: 'https://loginestacio.onmicrosoft.com/e62ba000-3cf5-463c-bfb2-2a632612a99a/user.read',
      },
      extraQueryParameters: {
        marca: 'estacio',
        codigo_grupo_marca: '1',
        grupo_marca_label: 'estacio',
        base_origin: 'https://candidatos.portal.estacio.br',
      },
    },
    applicationUrl: 'https://experimente.estacio.br',
  },
];
